// extracted by mini-css-extract-plugin
module.exports = {"autocomplete":"Country_autocomplete__13OnO","list":"Country_list__3goMe","list_item":"Country_list_item__20UfS"};